import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const renderStatusIcon = (value) => {
  return value ? <CheckCircleIcon sx={{ color: 'success.main' }} /> : <CancelIcon sx={{ color: 'error.main' }} />;
};

export const LensSyncTableHeader = () => [
  { field: 'slNo', headerName: 'Sl_No', width: 120, toolTipGetter: true },
  {
    field: 'admn_no',
    headerName: 'Admission No',
    width: 160,
    toolTipGetter: true,
  },

  {
    field: 'student_name',
    headerName: 'Student Name',
    width: 220,
    toolTipGetter: true,
  },
  {
    field: 'course_name',
    headerName: 'Course Name',
    width: 220,
    toolTipGetter: true,
  },
  {
    field: 'subject_name',
    headerName: 'Subject Name',
    width: 200,
    toolTipGetter: true,
  },
  {
    field: 'name',
    headerName: 'CRM name',
    width: 200,
    toolTipGetter: true,
  },
  {
    field: 'full_name',
    headerName: 'Tutor Name',
    width: 200,
    toolTipGetter: true,
  },
  //icons
  {
    field: 'scheduled_sessions_count',

    headerName: 'Scheduled Sessions',
    width: 190,
    renderCell: (params) => renderStatusIcon(params.row.scheduled_sessions_count),
  },

  {
    field: 'wise_student_id',
    headerName: 'Student Sync',
    width: 160,
    renderCell: (params) => renderStatusIcon(params.row.wise_student_id),
  },
  {
    field: 'wise_course_classroom_id',
    headerName: 'Course Sync',
    width: 160,
    renderCell: (params) => renderStatusIcon(params.row.wise_course_classroom_id),
  },
  {
    field: 'wise_teacher_id',
    headerName: 'Tutor Sync',
    width: 160,
    renderCell: (params) => renderStatusIcon(params.row.wise_teacher_id),
  },

  {
    field: 'studentSync',
    headerName: 'Student Sync Action',
    type: 'action',
    actionKey: 'studentSync',
    width: 180,
    buttonName: 'Sync',
  },
  {
    field: 'courseSync',
    headerName: 'Course Sync Action',
    type: 'action',
    actionKey: 'courseSync',
    width: 180,
    buttonName: 'Sync',
  },
  {
    field: 'tutorSync',
    headerName: 'Tutor Sync Action',
    type: 'action',
    actionKey: 'tutorSync',
    width: 180,
    buttonName: 'Sync',
  },
  {
    field: 'allSync',
    headerName: 'All Sync',
    type: 'action',
    actionKey: 'allSync',
    width: 160,
    buttonName: 'Sync All',
  },
];
